import { removePhoneRegExp, removePhoneStringReplace } from './maskRegex'

export const sanitizeLoginUsername = (str: string) => {
  let phoneRegex = /^\(?\d{2}\)?[\s-]?\d{4,5}[\s-]?\d{4}$/

  if (phoneRegex.test(str)) {
    return str.replace(removePhoneRegExp, removePhoneStringReplace)
  } else {
    return str.trim()
  }
}
